var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"float-right",attrs:{"variant":"light","size":_vm.size},on:{"click":function($event){return _vm.download()}}},[_vm._v(" Ladda ned ")])}
var staticRenderFns = []

export { render, staticRenderFns }